<script lang="ts">
	import { page } from '$app/stores';
	import { appTheme, switchTheme } from '$lib/utils/themeUtils';
	import { signOut } from '@auth/sveltekit/client';
	import DarkModeToggleButton from './DarkModeToggleButton.svelte';
	import Dropdown from './Dropdown.svelte';
	import UserAvatar from './UserAvatar.svelte';

	let dialogElement: HTMLDialogElement | null = null;
</script>

<dialog bind:this={dialogElement} class="dialog">
	<h2>Settings</h2>
</dialog>
{#if $page.data.session?.user == null}
	<DarkModeToggleButton />
	<a
		data-testid="login-button"
		href="/auth/signin"
		class="button small ml-2 mr-4 flex cursor-pointer gap-x-2 whitespace-nowrap !px-6 !py-1.5"
	>
		Log in</a
	>
{:else}
	<Dropdown
		options={[
			{
				text: $page.data.session?.user?.name ?? '',
				isLabel: true
			},
			{
				text: ($appTheme == 'light' ? 'Dark' : 'Light') + ' theme',
				handler: () => switchTheme()
			},
			{
				text: 'Preferences',
				handler: () => dialogElement?.showModal(),
				hidden: true
			},
			{
				text: 'Sign out',
				handler: () => signOut(),
				testId: 'sign-out'
			}
		]}
	>
		<div
			slot="label"
			class="cursor-pointer"
			data-avatar-user={$page.data.session?.user.id}
			data-testid="user-avatar"
		>
			<UserAvatar
				showTitleOnHover={false}
				name={$page.data.session?.user?.name}
				imageUrl={$page.data.session?.user?.image}
			/>
		</div>
	</Dropdown>
{/if}
